'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"


import message from './modules/message'
import progress from './modules/progress'
import auth from './modules/auth'
import project from './modules/project'
import storage from './modules/storage'
import lists from './modules/lists'
import sample from './modules/sample'
import probePlex from './modules/probePlex'
import plate from './modules/plate'
import seq from './modules/seq'


Vue.use(Vuex)

import createLogger from 'vuex/dist/logger'

const debug = process.env.NODE_ENV !== 'production'

const persistedState = createPersistedState({
	key: 'vuex',
	selected_storage: window.localStorage,
	paths: [
		'plate.plate_filter',
		'project.selected',
	]
})

const store = new Vuex.Store({
	modules: {
		message,
		progress,
		auth,
		project,
		storage,
		lists,
		sample,
		probePlex,
		plate,
		seq
	},
	strict: debug,
	plugins: debug ? [createLogger(), persistedState,] : [persistedState,],
})

export default store